export const EXCLUSIVE_SECTOR_OPTIONS = new Set([
  "aviation_subtypes.any",
  "aviation_subtypes.not_sure_yet",
]);

export const normalizeSectorSelection = (selection) => {
  let changed = false;
  const secondary = Object.fromEntries(
    Object.entries(selection.secondary).map(([sector, options]) => {
      const broadOption = options.find((option) =>
        EXCLUSIVE_SECTOR_OPTIONS.has(option),
      );
      if (!broadOption || options.length === 1) return [sector, options];

      changed = true;
      return [sector, [broadOption]];
    }),
  );

  return changed ? { ...selection, secondary } : selection;
};
